import type { RouteRecordRaw } from 'vue-router';

export const standardRoutes: RouteRecordRaw[] = [
  {
    name: 'standard-index',
    component: () => import('../pages/index.vue'),
    path: '/references/ai-baselines',
    meta: {
      middleware: 'auth',
    },
  },
];
